import { connect } from "react-redux";
import { setLoaderStatusAction, setLoaderTextAction } from "redux-store/loader";

import { NavLoaderProxy } from "./nav-loader-proxy";

function mapDispatchToProps(dispatch) {
  return {
    setLoaderStatus: (isLoading) => {
      dispatch(setLoaderStatusAction(isLoading));
    },
    setLoaderText: (loaderText) => {
      dispatch(setLoaderTextAction(loaderText));
    },
  };
}

const ConnectedNavLoaderProxy = connect(
  null,
  mapDispatchToProps,
)(NavLoaderProxy);

export { ConnectedNavLoaderProxy };
